(() => {
  'use strict';

  const ready = () => {
    const root = document.querySelector('[data-cr-buybox-v2]');
    if (!root || root.dataset.crBuyboxReady === 'true') return;
    root.dataset.crBuyboxReady = 'true';

    const mode = root.dataset.crBuyboxMode || 'legacy';
    const guidePlacement = root.dataset.crBuyboxGuidePlacement === 'true';
    const headerSync = root.dataset.crBuyboxPriceHeaderSync === 'true';
    const stickySync = root.dataset.crBuyboxStickySync === 'true';
    const parityFix = root.dataset.crBuyboxPriceParityFix === 'true';
    const form = root.querySelector('[data-cr-product-form]');
    if (!form) return;

    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const money = (cents) => {
      const value = Number(cents || 0) / 100;
      try {
        return value.toLocaleString(undefined, { style: 'currency', currency });
      } catch (_error) {
        return `$${value.toFixed(2)}`;
      }
    };

    const selectedVariantId = () => {
      const checked = form.querySelector('[name="id"]:checked');
      const hidden = form.querySelector('[name="id"]:not([type="radio"])');
      return String((checked || hidden || {}).value || '');
    };

    const selectedQuantity = () => {
      const field = form.querySelector('[name="quantity"]');
      return Math.max(1, Number(field && field.value) || 1);
    };

    const ensureParityMarker = () => {
      let marker = form.querySelector('[data-cr-price-parity-marker]');
      if (!marker && parityFix) {
        marker = document.createElement('input');
        marker.type = 'hidden';
        marker.name = 'properties[_cappyroots_price_parity]';
        marker.value = 'true';
        marker.setAttribute('data-cr-price-parity-marker', '');
        form.appendChild(marker);
      }
      if (marker) marker.disabled = !parityFix;
      return marker;
    };

    const updateHeader = ({ total, unitPrice, totalServings }) => {
      if (!headerSync) return;
      const priceNode = root.querySelector('[data-cr-price]');
      const perNode = root.querySelector('[data-cr-per-serving]');
      const servingsNode = root.querySelector('[data-cr-servings]');
      if (priceNode) priceNode.textContent = money(total);
      if (perNode) {
        const perServing = totalServings > 0 ? Math.round(total / totalServings) : 0;
        if (perServing > 0) {
          perNode.textContent = `${money(perServing)} ${perNode.getAttribute('data-cr-per-suffix') || 'per serving'}`;
          perNode.hidden = false;
        } else {
          perNode.hidden = true;
        }
      }
      if (servingsNode && totalServings > 0) servingsNode.textContent = String(totalServings);
      root.dataset.crBuyboxDisplayedUnit = money(unitPrice);
    };

    const syncStickyThumbnail = (mediaId) => {
      if (!stickySync) return;
      const thumbnail = document.querySelector('[data-cr-sticky-thumb]');
      if (!thumbnail) return;
      const wantedMediaId = String(mediaId || '');
      const slide = wantedMediaId ? Array.from(document.querySelectorAll('[data-cr-slide]')).find((item) => String(item.dataset.crMediaId || '') === wantedMediaId) : null;
      const stageImage = slide && slide.querySelector('img');
      const source = (stageImage && (stageImage.currentSrc || stageImage.src)) || thumbnail.dataset.crStickyFallbackSrc || '';
      if (source && thumbnail.src !== source) thumbnail.src = source;
    };

    const updateSticky = ({ variantId, variantTitle, quantity, total, mediaId = '' }) => {
      if (!stickySync) return;
      const bar = document.querySelector('[data-cr-stickybar]');
      if (!bar) return;
      const price = bar.querySelector('[data-cr-sticky-price]');
      const meta = bar.querySelector('[data-cr-sticky-meta]');
      const select = bar.querySelector('[data-cr-sticky-select]');
      if (price) price.textContent = money(total);
      if (meta) meta.textContent = quantity > 1 ? `${quantity} jars · ${variantTitle}` : variantTitle;
      if (select && select.value !== String(variantId)) select.value = String(variantId);
      syncStickyThumbnail(mediaId);
      bar.dataset.crBuyboxQuantity = String(quantity);
      bar.dataset.crBuyboxTotal = String(total);
    };

    const updateStickyClearance = () => {
      const bar = document.querySelector('[data-cr-stickybar]');
      if (bar && bar.classList.contains('is-visible')) {
        document.documentElement.style.setProperty('--cr-stickybar-clearance', `${Math.ceil(bar.getBoundingClientRect().height)}px`);
      }
    };

    const syncStickyCollapsedBody = (bar) => {
      if (!document.body) return;
      const mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      document.body.classList.toggle('cr-stickybar-collapsed', Boolean(bar && mobile && bar.classList.contains('is-collapsed')));
    };

    // Gorgias and Klaviyo are injected independently after the theme is ready. Their inline
    // offsets can differ even when the stylesheet uses the same fallback, so Gorgias's actual
    // visible bottom edge is measured and shared with the Klaviyo teaser in every mobile state.
    const widgetBottomProperty = '--cr-sticky-widget-bottom';
    // Klaviyo can render the teaser as a button rather than a div, and can apply its final inline
    // positioning after insertion. Match the named host regardless of element type.
    const teaserSelector = '[class*="kl-teaser-"]';
    const chatSelector = 'iframe#chat-button[title="Gorgias live chat messenger"]';
    const restoreChat = (chat) => {
      if (!chat || chat.dataset.crStickyChatManaged !== 'true') return;
      const bottom = chat.dataset.crStickyChatBottom || '';
      const priority = chat.dataset.crStickyChatBottomPriority || '';
      if (bottom) chat.style.setProperty('bottom', bottom, priority);
      else chat.style.removeProperty('bottom');
      delete chat.dataset.crStickyChatManaged;
      delete chat.dataset.crStickyChatBottom;
      delete chat.dataset.crStickyChatBottomPriority;
    };
    const preserveNativeChatOffset = (chat) => {
      if (!chat) return;
      if (chat.dataset.crStickyChatManaged !== 'true') {
        chat.dataset.crStickyChatManaged = 'true';
        chat.dataset.crStickyChatBottom = chat.style.getPropertyValue('bottom');
        chat.dataset.crStickyChatBottomPriority = chat.style.getPropertyPriority('bottom');
      }
      // Gorgias currently supplies 20px inline. Retain it rather than applying the old
      // sticky-bar clearance, so the actual chat button stays at its chosen resting position.
      const nativeBottom = chat.dataset.crStickyChatBottom || 'max(12px, calc(var(--cr-mobile-vv-bottom, 0px) + env(safe-area-inset-bottom)))';
      chat.style.setProperty('bottom', nativeBottom, 'important');
    };
    const restoreTeaser = (teaser) => {
      if (teaser.dataset.crStickyTeaserManaged !== 'true') return;
      const properties = ['bottom', 'margin-bottom'];
      properties.forEach((property) => {
        const value = teaser.dataset[`crStickyTeaser${property === 'bottom' ? 'Bottom' : 'MarginBottom'}`] || '';
        const priority = teaser.dataset[`crStickyTeaser${property === 'bottom' ? 'BottomPriority' : 'MarginBottomPriority'}`] || '';
        if (value) teaser.style.setProperty(property, value, priority);
        else teaser.style.removeProperty(property);
      });
      delete teaser.dataset.crStickyTeaserManaged;
      delete teaser.dataset.crStickyTeaserBottom;
      delete teaser.dataset.crStickyTeaserBottomPriority;
      delete teaser.dataset.crStickyTeaserMarginBottom;
      delete teaser.dataset.crStickyTeaserMarginBottomPriority;
    };
    const syncMobileWidgetBaseline = () => {
      const bar = document.querySelector('[data-cr-stickybar]');
      const mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      const visible = Boolean(mobile && bar && bar.classList.contains('is-visible'));
      const collapsed = Boolean(visible && bar.classList.contains('is-collapsed'));
      const keyboard = document.documentElement.getAttribute('data-cr-mobile-keyboard') === 'true';
      if (!mobile || keyboard) {
        document.documentElement.style.removeProperty(widgetBottomProperty);
        restoreChat(document.querySelector(chatSelector));
        document.querySelectorAll(teaserSelector).forEach(restoreTeaser);
        return;
      }
      const chat = document.querySelector(chatSelector);
      if (!chat) {
        document.documentElement.style.removeProperty(widgetBottomProperty);
        document.querySelectorAll(teaserSelector).forEach(restoreTeaser);
        return;
      }
      if (collapsed) preserveNativeChatOffset(chat);
      else restoreChat(chat);
      const box = chat.getBoundingClientRect();
      const visualBottom = (window.visualViewport?.offsetTop || 0) + (window.visualViewport?.height || window.innerHeight);
      if (!box.width || !box.height || box.bottom <= 0 || box.bottom > visualBottom + 2) {
        chat.addEventListener('load', scheduleMobileWidgetBaseline, { once: true });
        return;
      }
      const bottom = Math.max(0, Math.round(visualBottom - box.bottom));
      document.documentElement.style.setProperty(widgetBottomProperty, `${bottom}px`);
      document.querySelectorAll(teaserSelector).forEach((teaser) => {
        if (teaser.dataset.crStickyTeaserManaged !== 'true') {
          teaser.dataset.crStickyTeaserManaged = 'true';
          teaser.dataset.crStickyTeaserBottom = teaser.style.getPropertyValue('bottom');
          teaser.dataset.crStickyTeaserBottomPriority = teaser.style.getPropertyPriority('bottom');
          teaser.dataset.crStickyTeaserMarginBottom = teaser.style.getPropertyValue('margin-bottom');
          teaser.dataset.crStickyTeaserMarginBottomPriority = teaser.style.getPropertyPriority('margin-bottom');
        }
        const expectedBottom = `${bottom}px`;
        if (teaser.style.getPropertyValue('bottom') !== expectedBottom || teaser.style.getPropertyPriority('bottom') !== 'important') {
          teaser.style.setProperty('bottom', expectedBottom, 'important');
        }
        if (teaser.style.getPropertyValue('margin-bottom') !== '0px' || teaser.style.getPropertyPriority('margin-bottom') !== 'important') {
          teaser.style.setProperty('margin-bottom', '0px', 'important');
        }
      });
    };
    let widgetSyncFrame = 0;
    const scheduleMobileWidgetBaseline = () => {
      if (widgetSyncFrame) return;
      widgetSyncFrame = window.requestAnimationFrame(() => {
        widgetSyncFrame = 0;
        syncMobileWidgetBaseline();
      });
    };
    const retryMobileWidgetBaseline = () => {
      scheduleMobileWidgetBaseline();
      // Gorgias can insert its iframe before its internal button has a measurable size. These
      // bounded retries cover that third-party load sequence without a permanent polling loop.
      [120, 420, 1000, 1800].forEach((delay) => window.setTimeout(scheduleMobileWidgetBaseline, delay));
    };
    if (window.MutationObserver && document.body) {
      new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.type === 'childList' || mutation.target === document.body || (mutation.attributeName === 'style' && mutation.target.matches?.(teaserSelector)))) scheduleMobileWidgetBaseline();
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
    window.addEventListener('resize', scheduleMobileWidgetBaseline, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleMobileWidgetBaseline, { passive: true });

    const setStickyCollapsed = (collapsed) => {
      const bar = document.querySelector('[data-cr-stickybar]');
      const details = bar && bar.querySelector('[data-cr-sticky-details]');
      const toggle = bar && bar.querySelector('[data-cr-sticky-toggle]');
      if (!bar || !details || !toggle) return;
      details.hidden = collapsed;
      bar.classList.toggle('is-collapsed', collapsed);
      syncStickyCollapsedBody(bar);
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      toggle.setAttribute('aria-label', collapsed ? 'Show sticky add to cart' : 'Hide sticky add to cart');
      try { if ('inert' in details) details.inert = collapsed; } catch (_error) {}
      window.requestAnimationFrame(updateStickyClearance);
      retryMobileWidgetBaseline();
    };

    const updateStickyTierPrices = (choice) => {
      if (!stickySync) return;
      const bar = document.querySelector('[data-cr-stickybar]');
      const row = bar && bar.querySelector('[data-cr-sticky-tier-row]');
      if (!bar || !row) return;
      const values = ['one', 'two', 'three'];
      const choices = Array.from(form.querySelectorAll('[data-cr-buybox-choice]'));
      const active = choice && values.includes(choice.value) ? choice : null;
      if (mode !== 'routine' || !active || values.some((value) => !choices.some((item) => item.value === value))) {
        row.hidden = true;
        return;
      }
      row.hidden = false;
      values.forEach((value) => {
        const source = choices.find((item) => item.value === value);
        const button = row.querySelector(`[data-cr-sticky-tier-choice="${value}"]`);
        const price = row.querySelector(`[data-cr-sticky-tier-price="${value}"]`);
        const saving = row.querySelector(`[data-cr-sticky-tier-saving="${value}"]`);
        if (!source || !button || !price) return;
        price.textContent = money(Number(source.dataset.crTotal) || 0);
        const percentage = Math.max(0, Number(source.dataset.crPercent) || 0);
        if (saving) {
          saving.textContent = percentage > 0 ? `Save ${percentage}%` : '';
          saving.hidden = percentage === 0;
        }
        const selected = source === active;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.disabled = source.disabled;
      });
      // Keep the existing clearance during a tier switch. The trial option hides this row and
      // temporarily shortens the bar; recalculating document padding at that moment shifts the
      // reader upward by the same amount and makes the desktop header reveal itself. Clearance is
      // still recalculated for deliberate collapsed-state changes and normal visibility changes.
    };

    const placeLegacyGuide = () => {
      if (!guidePlacement || mode !== 'legacy') return;
      const legacyGuide = form.querySelector('[data-cr-variant-gift]');
      const submit = form.querySelector('[type="submit"]');
      if (!legacyGuide || !submit) return;
      legacyGuide.classList.add('cr-buybox-guide--legacy');
      legacyGuide.querySelectorAll('.cr-variant-gift__value').forEach((node) => node.remove());
      const note = legacyGuide.querySelector('.cr-variant-gift__note');
      if (note) note.textContent = 'Included free.';
      submit.before(legacyGuide);
    };

    const syncLegacy = () => {
      if (mode !== 'legacy') return;
      const radio = form.querySelector('[data-cr-variant-price]:checked');
      if (!radio) return;
      const quantity = selectedQuantity();
      const unitPrice = Number(radio.dataset.crVariantPriceCents || 0) || (() => {
        const text = String(radio.dataset.crVariantPrice || '').replace(/[^0-9.]/g, '');
        return Math.round(Number(text || 0) * 100);
      })();
      const servingsPerUnit = Number(radio.dataset.crVariantServings || 0);
      const compareTotal = unitPrice * quantity;
      const bundleVariant = String(form.dataset.crGuideBundleVariant || '');
      const qualifying = String(radio.value) === bundleVariant;
      const tier2 = Math.max(0, Math.min(100, Number(root.dataset.crBuyboxTier2) || 0));
      const tier3 = Math.max(0, Math.min(100, Number(root.dataset.crBuyboxTier3) || 0));
      const percent = qualifying ? (quantity >= 3 ? tier3 : quantity >= 2 ? tier2 : 0) : 0;
      const savings = Math.round(compareTotal * percent / 100);
      const total = compareTotal - savings;
      updateHeader({ total, unitPrice, totalServings: servingsPerUnit * quantity });
      updateSticky({ variantId: radio.value, variantTitle: radio.dataset.crVariantTitle || '', quantity, total });
      const marker = ensureParityMarker();
      if (marker) marker.disabled = !parityFix || !qualifying;
    };

    const syncRoutineGallery = (choice) => {
      if (mode !== 'routine' || !choice) return;
      const mediaId = String(choice.dataset.crVariantMedia || '');
      if (!mediaId) return;
      const track = document.querySelector('[data-cr-stage-track]');
      if (!track) return;
      const slides = Array.from(track.querySelectorAll('[data-cr-slide]'));
      const wanted = slides.find((slide) => String(slide.dataset.crMediaId || '') === mediaId);
      if (!wanted) return;
      const first = slides[0];
      const wantedIndex = Number(wanted.dataset.crSlide) || 0;
      const stickyVisible = Boolean(document.querySelector('[data-cr-stickybar].is-visible'));
      // While the shopper is using the fixed purchase control below the fold, the sticky thumbnail
      // already reflects this selected media. Do not scroll the distant main gallery: that browser
      // scroll dispatch can reveal the header and move the reading position even though the shopper
      // only changed a variant. The gallery still updates normally when the real buy box is visible.
      if (stickyVisible) {
        root.dataset.crBuyboxMediaId = mediaId;
        return;
      }
      const targetLeft = wanted.offsetLeft - (first ? first.offsetLeft : 0);
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: targetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = targetLeft;
      }

      const thumbs = Array.from(document.querySelectorAll('[data-cr-thumb]'));
      thumbs.forEach((thumb) => {
        const index = Number(thumb.dataset.crThumbIndex);
        thumb.setAttribute('aria-current', index === wantedIndex ? 'true' : 'false');
      });
      const activeThumb = thumbs.find((thumb) => Number(thumb.dataset.crThumbIndex) === wantedIndex);
      const strip = document.querySelector('.cr-pdp__thumbs');
      if (strip && activeThumb && strip.scrollWidth > strip.clientWidth + 2) {
        const left = activeThumb.offsetLeft - strip.offsetLeft;
        const right = left + activeThumb.offsetWidth;
        const viewLeft = strip.scrollLeft;
        const viewRight = viewLeft + strip.clientWidth;
        const padding = 12;
        let target = null;
        if (left < viewLeft + padding) target = Math.max(0, left - padding);
        else if (right > viewRight - padding) target = right - strip.clientWidth + padding;
        if (target !== null) {
          const max = strip.scrollWidth - strip.clientWidth;
          target = Math.max(0, Math.min(max, target));
          if (typeof strip.scrollTo === 'function') {
            strip.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
          } else {
            strip.scrollLeft = target;
          }
        }
      }
      document.querySelectorAll('[data-cr-dot]').forEach((dot) => {
        const index = Number(dot.dataset.crDot);
        if (index === wantedIndex) dot.setAttribute('data-active', 'true');
        else dot.removeAttribute('data-active');
      });
      root.dataset.crBuyboxMediaId = mediaId;
    };

    const setRoutineChoice = (choice) => {
      if (mode !== 'routine' || !choice || choice.disabled) return;
      const header = document.querySelector('.shopify-section-group-header-group.cr-header--hidden');
      const stickyHeaderLock = header && window.matchMedia && window.matchMedia('(min-width: 750px)').matches && document.querySelector('[data-cr-stickybar].is-visible');
      if (stickyHeaderLock) {
        // Changing to the trial option can reduce the buy-box content above the reader. Browser
        // scroll anchoring then emits a scroll update, which would otherwise reveal a header that
        // was intentionally hidden. Preserve only that pre-existing hidden desktop state during
        // the bounded variant update; normal user scrolling resumes immediately afterward.
        header.dataset.crVariantHeaderLock = 'true';
        const holdHidden = () => {
          if (header.dataset.crVariantHeaderLock !== 'true') return;
          header.classList.add('cr-header--sticky', 'cr-header--hidden');
          header.classList.remove('cr-header--animate');
        };
        holdHidden();
        window.requestAnimationFrame(holdHidden);
        window.setTimeout(holdHidden, 80);
        window.setTimeout(holdHidden, 260);
        window.setTimeout(holdHidden, 700);
        window.setTimeout(() => {
          delete header.dataset.crVariantHeaderLock;
        }, 900);
      }
      const variantId = String(choice.dataset.crVariantId || '');
      const variantTitle = choice.dataset.crVariantTitle || '';
      const quantity = Math.max(1, Number(choice.dataset.crQuantity) || 1);
      const unitPrice = Number(choice.dataset.crUnitPrice) || 0;
      const total = Number(choice.dataset.crTotal) || unitPrice * quantity;
      const servingsPerUnit = Number(choice.dataset.crServingsPerUnit) || 0;
      const hasGuide = choice.dataset.crHasGuide === 'true';
      const idField = form.querySelector('[data-cr-buybox-variant-id]');
      const quantityField = form.querySelector('[data-cr-buybox-quantity]');
      const parentGift = form.querySelector('[data-cr-parent-gift]');
      const marker = ensureParityMarker();
      const guide = form.querySelector('[data-cr-buybox-guide], [data-cr-variant-gift]');
      const submit = form.querySelector('[data-cr-buybox-submit]');
      const submitPrice = form.querySelector('[data-cr-buybox-submit-price]');

      form.querySelectorAll('[data-cr-buybox-option]').forEach((option) => option.classList.remove('is-selected'));
      const option = choice.closest('[data-cr-buybox-option]');
      if (option) option.classList.add('is-selected');
      if (!choice.checked) choice.checked = true;
      if (idField) idField.value = variantId;
      if (quantityField) {
        quantityField.value = String(quantity);
        quantityField.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (parentGift) parentGift.disabled = !hasGuide;
      if (marker) marker.disabled = !parityFix || !hasGuide;
      if (guide) guide.hidden = !hasGuide;
      if (submitPrice) submitPrice.textContent = money(total);
      if (submit) submit.disabled = choice.disabled;
      updateHeader({ total, unitPrice, totalServings: servingsPerUnit * quantity });
      updateSticky({ variantId, variantTitle, quantity, total, mediaId: choice.dataset.crVariantMedia || '' });
      updateStickyTierPrices(choice);
      syncRoutineGallery(choice);
      root.dataset.crBuyboxSelection = choice.value;
      root.dataset.crBuyboxQuantity = String(quantity);
      root.dataset.crBuyboxTotal = String(total);
    };

    const initializeRoutine = () => {
      const choices = Array.from(form.querySelectorAll('[data-cr-buybox-choice]'));
      if (!choices.length) return;
      choices.forEach((choice) => {
        choice.addEventListener('change', () => {
          if (choice.checked) setRoutineChoice(choice);
        });
      });
      const initial = choices.find((choice) => choice.checked && !choice.disabled) || choices.find((choice) => !choice.disabled);
      if (initial) setRoutineChoice(initial);

      const bar = document.querySelector('[data-cr-stickybar]');
      if (bar) {
        bar.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-cr-sticky-toggle]');
          if (toggle) {
            event.preventDefault();
            setStickyCollapsed(toggle.getAttribute('aria-expanded') === 'true');
            return;
          }
          const target = event.target.closest('[data-cr-sticky-tier-choice]');
          if (!target || target.disabled) return;
          const choice = choices.find((item) => item.value === target.dataset.crStickyTierChoice);
          if (!choice || choice.disabled) return;
          choice.checked = true;
          choice.dispatchEvent(new Event('change', { bubbles: true }));
        });
        setStickyCollapsed(false);
        window.addEventListener('resize', () => syncStickyCollapsedBody(bar), { passive: true });
      }

      document.addEventListener('change', (event) => {
        const select = event.target.closest('[data-cr-sticky-select]');
        if (!select || mode !== 'routine') return;
        let target = choices.find((choice) => String(choice.dataset.crVariantId) === String(select.value) && choice.checked);
        if (!target) {
          target = choices.find((choice) => String(choice.dataset.crVariantId) === String(select.value) && choice.value === 'two') ||
            choices.find((choice) => String(choice.dataset.crVariantId) === String(select.value));
        }
        if (target) setRoutineChoice(target);
      });
    };

    const initializeSubscription = () => {
      const type = form.querySelector('[data-cr-buybox-purchase-type]');
      const sellingPlan = form.querySelector('[data-cr-buybox-selling-plan]');
      const cadence = form.querySelector('[data-cr-buybox-cadence]');
      if (!type || !sellingPlan || !cadence) return;
      type.addEventListener('change', (event) => {
        const choice = event.target.closest('input[name="cr_purchase_type"]');
        if (!choice) return;
        const subscribe = choice.value === 'subscribe';
        sellingPlan.disabled = !subscribe;
        cadence.hidden = !subscribe;
      });
    };

    ensureParityMarker();
    placeLegacyGuide();
    initializeRoutine();
    initializeSubscription();
    syncLegacy();

    if (mode === 'legacy') {
      form.addEventListener('change', () => window.setTimeout(syncLegacy, 0));
      form.addEventListener('input', (event) => {
        if (event.target.matches('[name="quantity"]')) window.setTimeout(syncLegacy, 0);
      });
      form.addEventListener('click', (event) => {
        if (event.target.closest('[data-cr-qty-step]')) window.setTimeout(syncLegacy, 0);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
